export default {
  GSO: {
    bannerHeadline: "Thank you for your booking!",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired. Make future bookings faster and manage your travels with Piedmont Triad International by creating an account.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "/privacy.html",
    faqLabel: "Support and FAQ",
    faqLink: "https://flyfrompti.com/airport-parking/",
    myAccountLink: "https://accounts.flyfrompti.com/",
    termsAndConditionsLink: "/terms.html",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Thank you for your booking!",
      message: "You will receive a parking confirmation in your inbox which will contain your QR code along with access to your tickets and receipt."
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "Support and FAQ",
      questionTitle: "Questions?",
      questionText: "Have a question about your parking reservation or navigating the Airport?",
      reviewFaqText: "Please review our FAQ.",
      faqButton: "Read FAQ"
    },
    manageBooking: {
      title: "Manage Your Booking",
      text: "Manage your booking anytime by logging into your account. In the 'Manage My Booking' section, you can view your bookings, access your QR code and receipts, and make changes to your reservation.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Make Another Booking",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "Support and FAQ",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },
  ST1: {
    bannerHeadline: "Thank you for your booking!",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired. Make future bookings faster and manage your travels by creating an account.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "https://www.abm.com/privacy-policy",
    faqLabel: "Support and FAQ",
    faqLink: "https://parkstl.abmvantage.com/faqs.html",
    myAccountLink: "https://stlmyaccount.abmvantage.com/",
    termsAndConditionsLink: "https://res.cloudinary.com/rezcomm2018/image/upload/v1787046789/abm/STL_Terms.pdf",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Thank you for your booking!",
      message: "You will receive a booking confirmation by email containing your QR code, booking details and receipt."
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "Help and FAQs",
      questionTitle: "Questions?",
      questionText: "Have a question about your parking reservation?",
      reviewFaqText: "View our FAQ.",
      faqButton: "View FAQs"
    },
    manageBooking: {
      title: "Manage Your Booking",
      text: "Use \"Manage My Booking\" to view your booking, access your QR code and receipt, and make eligible changes to your reservation.",
      button: "Manage Booking"
    },
    makeAnotherBooking: {
      title: "Need another parking booking?",
      button: "Make Another Booking",
      text: "Make another booking"
    },
    nextStepsSection: {
      headline: "Help and FAQs",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },
  YHM: {
    bannerHeadline: "Thank you for your booking!",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired. Make future bookings faster and manage your travels with Hamilton International by creating an account.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "https://flyhamilton.ca/privacy-policy/",
    faqLabel: "Support and FAQ",
    faqLink: "https://flyhamilton.ca/faq/",
    myAccountLink: "https://yhmmyaccountstaging.rezcomm.com/",
    termsAndConditionsLink: "/terms.html",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Thank you for your booking!",
      message: "You will receive a parking confirmation in your inbox which will contain your QR code along with access to your tickets and receipt."
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "Support and FAQ",
      questionTitle: "Questions?",
      questionText: "Have a question about your parking reservation or navigating the Airport?",
      reviewFaqText: "Please review our FAQ.",
      faqButton: "Read FAQ"
    },
    manageBooking: {
      title: "Manage Your Booking",
      text: "Manage your booking anytime by logging into your account. In the 'Manage My Booking' section, you can view your bookings, access your QR code and receipts, and make changes to your reservation.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Make Another Booking",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "Support and FAQ",
      description: "Have a question about your parking reservation or navigating the Airport?",
      linkText: "Read FAQ",
      linkUrl: "https://flyhamilton.ca/faq/"
    }
  },
  SV1: {
    bannerHeadline: "Thank you!",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired. Make future bookings faster and manage your travels with Summit by creating an account.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "https://www.summitairportparking.com/legal/privacy",
    faqLabel: "Support and FAQ",
    faqLink: "https://www.summitairportparking.com/faq",
    myAccountLink: "https://sv1managemyaccountstaging.rezcomm.com/",
    termsAndConditionsLink: "https://www.summitairportparking.com/legal/terms",
    accountCreatedTitle: "Cheers to a smoother booking experience!",
    accountCreatedSubtitle: "",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Payment Confirmed!",
      message: "You will receive a parking confirmation in your inbox which will contain your QR code along with access to your tickets and receipt."
    },
    cartMessage: {
      headline: "Payment Confirmed!",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "Support and FAQ",
      questionTitle: "Questions?",
      questionText: "Have a question about your parking reservation or navigating the Airport?",
      reviewFaqText: "Please review our FAQ.",
      faqButton: "Read FAQ"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Continue Shopping",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "Support and FAQ",
      description: "Have a question about your parking reservation or navigating the Airport?",
      linkText: "Read FAQ",
      linkUrl: "https://www.summitairportparking.com/faq"
    }
  },
  RDU: {
    bannerHeadline: "Thank you for your booking!",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "https://www.rdu.com/privacy/",
    faqLabel: "Support and FAQ",
    faqLink: "https://www.rdu.com/parking/parking-faq/",
    myAccountLink: "https://accounts.rdu.com/",
    termsAndConditionsLink: "https://booking.rdu.com/terms.html",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: "If you do not receive the confirmation email within a few minutes of booking, please check your Spam folder."
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Amount Paid"
    },
    faqSection: {
      headline: "Support and FAQ",
      questionTitle: "Questions?",
      questionText: "You will receive an email that includes a QR Code and confirmation of your reservation details. Please present the QR code for entry at the gate. If you do not receive an email and/or QR code, please call the Parking office at (919) 840-2140 or contact us via email at rduparking@rdu.com.",
      reviewFaqText: "",
      faqButton: ""
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You may login to your account and manage your booking. By doing this you can amend, upgrade, cancel* your booking.",
      importantNote: "Important note:",
      restriction: "You are unable to Amend/Cancel within 24 hours of your booking start time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Make Another Booking",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "Support and FAQ",
      description: "You will receive an email that includes a QR Code and confirmation of your reservation details. Please present the QR code for entry at the gate. If you do not receive an email and/or QR code, please call the Parking office at (919) 840-2140 or contact us via email at rduparking@rdu.com.",
      linkText: "Contact Parking Office",
      linkUrl: "mailto:rduparking@rdu.com"
    }
  },
  RSW: {
    bannerHeadline: "Your Payment has been successful",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "https://rswstaging.rezcomm.com/privacy.html",
    faqLabel: "Support and FAQ",
    faqLink: "https://rswstaging.rezcomm.com/faqs.html",
    myAccountLink: "https://rswmanagemyaccountstaging.rezcomm.com",
    termsAndConditionsLink: "https://rswstaging.rezcomm.com/terms.html",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: "If you do not receive the confirmation email within a few minutes of booking, please check your Spam folder."
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "Support and FAQ",
      questionTitle: "Questions?",
      questionText: "Have a question about your parking reservation or navigating the Airport?",
      reviewFaqText: "Please review our FAQ.",
      faqButton: "Read FAQ"
    },
    manageBooking: {
      title: "Manage Your Booking",
      text: "Manage your booking anytime by logging into your account.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Make Another Booking",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "Support and FAQ",
      description: "Have a question about your parking reservation or navigating the Airport?",
      linkText: "Read FAQ",
      linkUrl: "https://rswstaging.rezcomm.com/faqs.html"
    }
  },
  PV1: {
    bannerHeadline: "Your Payment has been successful",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "https://stage.pvdairpark.com/privacy",
    faqLabel: "Support and FAQ",
    faqLink: "https://stage.pvdairpark.com/#faq",
    myAccountLink: "https://pv1managemyaccountstaging.rezcomm.com",
    termsAndConditionsLink: "https://stage.pvdairpark.com/terms",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: "If you do not receive the confirmation email within a few minutes of booking, please check your Spam folder."
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Amount Paid"
    },
    faqSection: {
      headline: "Support and FAQ",
      questionTitle: "Questions?",
      questionText: "Have a question about your parking reservation or navigating the Airport?",
      reviewFaqText: "Please review our FAQ.",
      faqButton: "Read FAQ"
    },
    manageBooking: {
      title: "Manage Your Booking",
      text: "Manage your booking anytime by logging into your account.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Make Another Booking",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "Support and FAQ",
      description: "Have a question about your parking reservation or navigating the Airport?",
      linkText: "Read FAQ",
      linkUrl: "https://stage.pvdairpark.com/#faq"
    }
  },
  HER: {
    bannerHeadline: "Your Payment has been successful",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "https://www.hermesairports.com/privacy-notice",
    faqLabel: "Support and FAQ",
    faqLink: "https://www.hermesairports.com/prepare-your-journey/fly-out/access--parking/assistance",
    myAccountLink: "https://myaccount.hermesairports.com/",
    termsAndConditionsLink: "https://www.hermesairports.com/terms-and-conditions-of-use",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: "If you do not receive the confirmation email within a few minutes of booking, please check your Spam folder."
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Amount Paid"
    },
    faqSection: {
      headline: "Support and FAQ",
      questionTitle: "Questions?",
      questionText: "Have a question about your parking reservation or navigating the Airport?",
      reviewFaqText: "Please review our FAQ.",
      faqButton: "Read FAQ"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You may login to your account and manage your booking. By doing this you can amend, upgrade, cancel* your booking or change your VRN.",
      importantNote: "Important note:",
      restriction: "Amendments can be processed at least 12 hours before the start of your booking. For VRN change can be made at least 6 hours before your booking starts.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Make Another Booking",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "Support and FAQ",
      description: "Have a question about your parking reservation or navigating the Airport?",
      linkText: "Read FAQ",
      linkUrl: "https://www.hermesairports.com/prepare-your-journey/fly-out/access--parking/assistance"
    }
  },
  NWI: {
    bannerHeadline: "Your Payment has been successful",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "https://www.norwichairport.co.uk/privacy-policy/",
    faqLabel: "Support and FAQ",
    faqLink: "https://www.norwichairport.co.uk/car-parking/",
    myAccountLink: "https://myaccount.prebook-norwichairport.com/",
    termsAndConditionsLink: "https://www.norwichairport.co.uk/terms-of-use/",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: "If you do not receive the confirmation email within a few minutes of booking, please check your Spam folder."
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Amount Paid"
    },
    faqSection: {
      headline: "Support and FAQ",
      questionTitle: "Questions?",
      questionText: "Have a question about your parking reservation or navigating the Airport?",
      reviewFaqText: "Please review our FAQ.",
      faqButton: "Read FAQ"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time. You can view your booking, pay your balance or your add passport details.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Make Another Booking",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "Support and FAQ",
      description: "Have a question about your parking reservation or navigating the Airport?",
      linkText: "Read FAQ",
      linkUrl: "https://www.norwichairport.co.uk/car-parking/"
    }
  },
  JER: {
    bannerHeadline: "Your Payment has been successful",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "https://www.jerseyairport.com/privacynotice",
    faqLabel: "Support and FAQ",
    faqLink: "https://www.jerseyairport.com/parking/long-stay/",
    myAccountLink: "https://jermanagemyaccountstaging.rezcomm.com",
    termsAndConditionsLink: "https://www.jerseyairport.com/terms-and-conditions",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: "If you do not receive the confirmation email within a few minutes of booking, please check your Spam folder."
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Amount Paid"
    },
    faqSection: {
      headline: "Support and FAQ",
      questionTitle: "Questions?",
      questionText: "Have a question about your parking reservation or navigating the Airport?",
      reviewFaqText: "Please review our FAQ.",
      faqButton: "Read FAQ"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "Want to see your booking? Need to change something or cancel all together? Log in and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Make Another Booking",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "Keep an eye out for your booking confirmation email",
      description: "You will receive an immediate email confirmation of your booking in your inbox. If you cannot locate it, please check your spam filter.",
      linkText: "Read FAQs",
      linkUrl: "https://www.jerseyairport.com/parking/long-stay/"
    }
  },
  PB1: {
    bannerHeadline: "Your Payment has been successful",
    guestTitle: "You Have Checked Out as a Guest",
    guestNote: "As a guest, your booking history will be erased three months after your booking has expired.",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyLink: "https://pbw.de/?menu=rechtliches",
    faqLabel: "Support and FAQ",
    faqLink: "https://pbw.de/?menu=vparken-faq",
    myAccountLink: "https://pb1managemyaccountstaging.rezcomm.com/",
    termsAndConditionsLink: "https://pbw.de/?menu=rechtliches",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: "If you do not receive the confirmation email within a few minutes of booking, please check your Spam folder."
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Amount Paid"
    },
    faqSection: {
      headline: "Support and FAQ",
      questionTitle: "Questions?",
      questionText: "Have a question about your parking reservation or navigating the Airport?",
      reviewFaqText: "Please review our FAQ.",
      faqButton: "Read FAQ"
    },
    manageBooking: {
      title: "Manage Your Booking",
      text: "Manage your booking anytime by logging into your account.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Make Another Booking",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "Read our FAQ",
      description: "For help and support with any of your pre-visit or post-visit queries, browse through our frequently asked questions.",
      linkText: "Read FAQs",
      linkUrl: "https://yourbrand.com/faqs"
    }
  },
  FMM: {
    bannerHeadline: "Your booking was successful!",
    guestTitle: "Please note you have checked out as a guest.",
    guestNote: "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our Privacy Notice.",
    privacyPolicyLabel: "Privacy Notice",
    privacyPolicyLink: "https://www.memmingen-airport.de/datenschutz/",
    faqLabel: "FAQs",
    faqLink: "https://www.memmingen-airport.de/faqs/",
    myAccountLink: "https://fmmmanagemyaccountstaging.rezcomm.com/",
    termsAndConditionsLink: "https://www.memmingen-airport.de/agb-parken/",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: ""
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "What happens next",
      questionTitle: "Read our FAQ",
      questionText: "For help and support with any of your pre-travel or after travel queries, browse through our frequently asked questions.",
      reviewFaqText: "",
      faqButton: "Read FAQs"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage my Booking"
    },
    makeAnotherBooking: {
      title: "Additional Services",
      button: "Purchase a Fast Track Ticket",
      text: "Get through security faster"
    },
    nextStepsSection: {
      headline: "What happens next",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },

  BFS: {
    bannerHeadline: "Success!",
    guestTitle: "Please note you have checked out as a guest.",
    guestNote: "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our Privacy Notice.",
    privacyPolicyLabel: "Privacy Notice",
    privacyPolicyLink: "/privacy.html",
    faqLabel: "FAQs",
    faqLink: "https://www.belfastairport.com/faqs/parking-faqs",
    myAccountLink: "https://bfsmanagemyaccountstaging.rezcomm.com/",
    termsAndConditionsLink: "/terms.html",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: ""
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "What happens next",
      questionTitle: "Read our FAQ",
      questionText: "For help and support with any of your pre-travel or after travel queries, browse through our frequently asked questions.",
      reviewFaqText: "",
      faqButton: "Read FAQs"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Continue Shopping",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "What happens next",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },

  NUE: {
    bannerHeadline: "Success!",
    guestTitle: "Please note you have checked out as a guest.",
    guestNote: "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our Privacy Notice.",
    privacyPolicyLabel: "Privacy Notice",
    privacyPolicyLink: "https://www.airport-nuernberg.de/datenschutz",
    faqLabel: "FAQs",
    faqLink: "https://www.airport-nuernberg.de/faq-parken",
    myAccountLink: "https://nuemanagemyaccountstaging.rezcomm.com/",
    termsAndConditionsLink: "https://www.airport-nuernberg.de/impressum",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: ""
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "What happens next",
      questionTitle: "Read our FAQ",
      questionText: "For help and support with any of your pre-travel or after travel queries, browse through our frequently asked questions.",
      reviewFaqText: "",
      faqButton: "Read FAQs"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Continue Shopping",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "What happens next",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },

  BHX: {
    bannerHeadline: "Success!",
    guestTitle: "Please note you have checked out as a guest.",
    guestNote: "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our Privacy Notice.",
    privacyPolicyLabel: "Privacy Notice",
    privacyPolicyLink: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/?#6T4jqJ04CLyjmyB7VWzVXN",
    faqLabel: "FAQs",
    faqLink: "/faqs.html",
    myAccountLink: "https://mybookings.birminghamairport.co.uk", 
    termsAndConditionsLink: "/terms.html",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: ""
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "What happens next",
      questionTitle: "Read our FAQ",
      questionText: "For help and support with any of your pre-travel or after travel queries, browse through our frequently asked questions.",
      reviewFaqText: "",
      faqButton: "Read FAQs"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Continue Shopping",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "What happens next",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },

  BH2: {
    bannerHeadline: "Success!",
    guestTitle: "Please note you have checked out as a guest.",
    guestNote: "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our Privacy Notice.",
    privacyPolicyLabel: "Privacy Notice",
    privacyPolicyLink: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/?#6T4jqJ04CLyjmyB7VWzVXN",
    faqLabel: "FAQs",
    faqLink: "/faqs.html",
    myAccountLink: "https://mybookings.birminghamairport.co.uk",
    termsAndConditionsLink: "/terms.html",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: ""
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "What happens next",
      questionTitle: "Read our FAQ",
      questionText: "For help and support with any of your pre-travel or after travel queries, browse through our frequently asked questions.",
      reviewFaqText: "",
      faqButton: "Read FAQs"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Continue Shopping",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "What happens next",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },
  SB2: {
    bannerHeadline: "Success!",
    guestTitle: "Please note you have checked out as a guest.",
    guestNote: "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our Privacy Notice.",
    privacyPolicyLabel: "Privacy Notice",
    privacyPolicyLink: "https://stpancras-highspeed.com/privacy-policy/",
    faqLabel: "FAQs",
    faqLink: "https://www.sabaparking.co.uk/en/faq",
    myAccountLink: "https://account.stpancrasintlparking.co.uk",
    termsAndConditionsLink: "https://stpancras-highspeed.com/terms-conditions/",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: ""
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "What happens next",
      questionTitle: "Read our FAQ",
      questionText: "For help and support with any of your pre-travel or after travel queries, browse through our frequently asked questions.",
      reviewFaqText: "",
      faqButton: "Read FAQs"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Continue Shopping",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "What happens next",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },
  SB3: {
    bannerHeadline: "Success!",
    guestTitle: "Please note you have checked out as a guest.",
    guestNote: "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our Privacy Notice.",
    privacyPolicyLabel: "Privacy Notice",
    privacyPolicyLink: "https://stpancras-highspeed.com/privacy-policy/",
    faqLabel: "FAQs",
    faqLink: "https://www.sabaparking.co.uk/en/faq",
    myAccountLink: "https://account.stpancrasintlparking.co.uk",
    termsAndConditionsLink: "https://stpancras-highspeed.com/terms-conditions/",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: ""
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "What happens next",
      questionTitle: "Read our FAQ",
      questionText: "For help and support with any of your pre-travel or after travel queries, browse through our frequently asked questions.",
      reviewFaqText: "",
      faqButton: "Read FAQs"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Continue Shopping",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "What happens next",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },
  SB4: {
    bannerHeadline: "Success!",
    guestTitle: "Please note you have checked out as a guest.",
    guestNote: "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our Privacy Notice.",
    privacyPolicyLabel: "Privacy Notice",
    privacyPolicyLink: "https://stpancras-highspeed.com/privacy-policy/",
    faqLabel: "FAQs",
    faqLink: "https://www.sabaparking.co.uk/en/faq",
    myAccountLink: "https://account.stpancrasintlparking.co.uk",
    termsAndConditionsLink: "https://stpancras-highspeed.com/terms-conditions/",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: ""
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "What happens next",
      questionTitle: "Read our FAQ",
      questionText: "For help and support with any of your pre-travel or after travel queries, browse through our frequently asked questions.",
      reviewFaqText: "",
      faqButton: "Read FAQs"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Continue Shopping",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "What happens next",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },
  SB5: {
    bannerHeadline: "Success!",
    guestTitle: "Please note you have checked out as a guest.",
    guestNote: "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our Privacy Notice.",
    privacyPolicyLabel: "Privacy Notice",
    privacyPolicyLink: "https://stpancras-highspeed.com/privacy-policy/",
    faqLabel: "FAQs",
    faqLink: "https://www.sabaparking.co.uk/en/faq",
    myAccountLink: "https://account.stpancrasintlparking.co.uk",
    termsAndConditionsLink: "https://stpancras-highspeed.com/terms-conditions/",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: ""
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "What happens next",
      questionTitle: "Read our FAQ",
      questionText: "For help and support with any of your pre-travel or after travel queries, browse through our frequently asked questions.",
      reviewFaqText: "",
      faqButton: "Read FAQs"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Continue Shopping",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "What happens next",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  },
  // Add other brands as needed...
  DEFAULT: {
    bannerHeadline: "Success!",
    guestTitle: "Please note you have checked out as a guest.",
    guestNote: "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our Privacy Notice.",
    privacyPolicyLabel: "Privacy Notice",
    privacyPolicyLink: "",
    faqLabel: "FAQs",
    faqLink: "",
    myAccountLink: "",
    termsAndConditionsLink: "",
    accountCreatedTitle: "Congratulations! Account creation was successful.",
    accountCreatedSubtitle: "Now you can book faster, view old bookings and manage new ones.",
    accountCreatedButton: "Get Started",
    accountCreatedBox: "Account created",
    confirmation: {
      headline: "Your Payment has been successful",
      message: ""
    },
    cartMessage: {
      headline: "Your Payment has been successful",
      message: "Your booking is currently in progress and we will email you as soon as the reservation is completed."
    },
    bookingSummary: {
      headline: "Your Booking Summary",
      amountPaidLabel: "Total"
    },
    faqSection: {
      headline: "What happens next",
      questionTitle: "Read our FAQ",
      questionText: "For help and support with any of your pre-travel or after travel queries, browse through our frequently asked questions.",
      reviewFaqText: "",
      faqButton: "Read FAQs"
    },
    manageBooking: {
      title: "Manage your booking",
      text: "You can login to your account and manage your booking at any time.",
      button: "Manage Account"
    },
    makeAnotherBooking: {
      title: "Did you forget something?",
      button: "Continue Shopping",
      text: "Make another purchase"
    },
    nextStepsSection: {
      headline: "What happens next",
      description: "",
      linkText: "",
      linkUrl: ""
    }
  }
};